export const getIntroText = (type, allRounds) => {
    let introText = {
      'round1': function() {
        return allRounds[0].introText.replace(/\[|\]/gi, '')
      },
      'round2': function(){
        return allRounds[1].introText.replace(/\[|\]/gi, '')
      },
      'round3': function(){
        return allRounds[2].introText.replace(/\[|\]/gi, '')
      },
      'round4': function(){
        return allRounds[3].introText.replace(/\[|\]/gi, '')
      }
    }
    return introText[type]();
  }

export const checkSolution = (type, newData, allRounds) => {
  let solutionCheck = {
    'round1': function() {
      if (allRounds[0].solution === newData){
        return true
      } else {
        return false
      }
    },
    'round2': function() {
      if(allRounds[1].solution === newData){
        return true
      } else {
        return false
      }
    },
    'round3': function() {
      if(allRounds[2].solution === newData){
        return true
      } else {
        return false
      }
    },
    'round4': function() {
      if(allRounds[3].solution === newData){
        return true
      } else {
        return false
      }
    },
  }
  return solutionCheck[type]();
}

export const returnHints = (type, allRounds) => {

  let hintCheck = {
    'round1': function () {
      const hints = allRounds[0].hints
      return hints
    },
    'round2': function () {
      const hints = allRounds[1].hints
      return hints
    },
    'round3': function () {
      const hints = allRounds[2].hints
      return hints
    },
    'round4': function () {
      const hints = allRounds[3].hints
      return hints
    }
  }
  return hintCheck[type]();
}

export const nmbrOfChars = (type, game, round) => {

  let nmbrOfCharsCheck = {
    'round1': function () {
      if (game.playerGame.rounds[0].solution) {
        const chars = game.playerGame.rounds[0].solution
        return chars
      } else {
        return null
      }
    },
    'round2': function () {
      if (game.playerGame.rounds[1].solution) {
        const chars = game.playerGame.rounds[1].solution
        return chars
      } else {
        return null
      }
    },
    'round3': function () {
      if (game.playerGame.rounds[2].solution) {
        const chars = game.playerGame.rounds[2].solution
        return chars
      } else {
        return null
      }
    },
    'round4': function () {
      if (game.playerGame.rounds[3].solution) {
        const chars = game.playerGame.rounds[3].solution
        return chars
      } else {
        return null
      }
    },
  }
  return nmbrOfCharsCheck[type]();
}
